<template lang="pug">
.statistics-page.flex.column
  .toolbar.flex.column.gap-12
    .row.flex.align-end.gap-12
      .col.flex.column.align-start.gap-6
        .title.font-size-12 時間區間
        el-date-picker.date-range-input(
          v-model="times"
          type="daterange"
          range-separator="至"
          start-placeholder="開始日期"
          end-placeholder="結束日期"
          :picker-options="datePickerOptions")
      .col.flex.column.align-start.gap-6
        .title.font-size-12 時間欄位
        el-select(v-model="timeField" style="width: 130px")
          el-option(value="start_at", label="預約開始時間")
          el-option(value="end_at", label="預約結束時間")
          el-option(value="created_at", label="建立時間")
      .col.flex.column.align-start.gap-6
        .title.font-size-12 時間粒度
        el-select(v-model="timeBucket" style="width: 130px")
          el-option(
            v-for="b in catalog.time_buckets"
            :key="b"
            :value="b"
            :label="bucketLabel(b)")
      .col.flex.column.align-start.gap-6
        .title.font-size-12 時區
        el-select(v-model="timezone" style="width: 130px")
          el-option(
            v-for="tz in catalog.timezones"
            :key="tz"
            :value="tz"
            :label="tz")
      .col.flex.column.align-start.gap-6
        .title.font-size-12 快速區間
        el-radio-group(v-model="quickRange", size="small", @change="applyQuickRange")
          el-radio-button(label="thisMonth") 本月
          el-radio-button(label="lastMonth") 上月
          el-radio-button(label="last3Months") 近 3 個月
          el-radio-button(label="thisYear") 本年
          el-radio-button(label="lastYear") 去年
    .row.flex.align-end.gap-12
      .col.flex.column.align-start.gap-6.flex-1
        .title.font-size-12 維度（最多 5 個）
        el-select.fill(
          v-model="dimensions"
          multiple
          filterable
          collapse-tags
          :multiple-limit="5"
          placeholder="例如：館別、預約類型")
          el-option(
            v-for="d in catalog.dimensions"
            :key="d"
            :value="d"
            :label="dimensionLabel(d)")
      .col.flex.column.align-start.gap-6.flex-1
        .title.font-size-12 指標
        el-select.fill(
          v-model="metrics"
          multiple
          filterable
          collapse-tags
          placeholder="至少選一個指標")
          el-option(
            v-for="m in catalog.metrics"
            :key="m.name"
            :value="m.name"
            :label="metricLabel(m.name)"
            :title="m.description")
    .row.flex.align-end.gap-12
      .col.flex.column.align-start.gap-6
        .title.font-size-12 館別篩選
        el-select(
          v-model="filterBranches"
          multiple
          collapse-tags
          clearable
          placeholder="不限"
          style="min-width: 200px")
          el-option(
            v-for="b in branches"
            :key="b.id"
            :value="b.id"
            :label="b.name")
      .col.flex.column.align-start.gap-6
        .title.font-size-12 預約類型
        el-select(
          v-model="filterAppointmentTypes"
          multiple
          collapse-tags
          clearable
          placeholder="不限"
          style="min-width: 200px")
          el-option(
            v-for="t in appointmentTypeOptions"
            :key="t.value"
            :value="t.value"
            :label="t.label")
      .col.flex.column.align-start.gap-6
        .title.font-size-12 議題
        el-select(
          v-model="filterMainRequirements"
          multiple
          collapse-tags
          clearable
          placeholder="不限"
          style="min-width: 200px")
          el-option(
            v-for="t in mainRequirementTypeOptions"
            :key="t.value"
            :value="t.value"
            :label="t.label")
      .col.flex.column.align-start.gap-6
        .title.font-size-12 是否包含取消
        el-switch(v-model="includeCancelled")
    .row.flex.align-end.gap-12
      .col.flex.column.align-start.gap-6
        .title.font-size-12 專業人士
        el-select(
          v-model="filterProfessionals"
          multiple
          filterable
          collapse-tags
          clearable
          placeholder="不限"
          style="min-width: 220px")
          el-option(
            v-for="p in professionalOptions"
            :key="p.value"
            :value="p.value"
            :label="p.label")
      .col.flex.column.align-start.gap-6
        .title.font-size-12 專案
        el-select(
          v-model="filterProjects"
          multiple
          filterable
          :filter-method="onProjectFilter"
          collapse-tags
          clearable
          placeholder="不限"
          style="min-width: 220px")
          el-option-group(
            v-for="g in projectOptionGroups"
            :key="g.label"
            :label="g.label")
            el-option(
              v-for="p in g.options"
              :key="p.value"
              :value="p.value"
              :label="p.label")
      .col.flex.column.align-start.gap-6
        .title.font-size-12 主訴標籤
        el-select(
          v-model="filterRecordTags"
          multiple
          filterable
          collapse-tags
          clearable
          placeholder="不限"
          style="min-width: 260px")
          el-option-group(
            v-for="g in recordTagGroups"
            :key="g.type"
            :label="g.label")
            el-option(
              v-for="t in g.options"
              :key="t.value"
              :value="t.value"
              :label="t.label")
    .row.flex.align-end.gap-12
      .col.flex.column.align-start.gap-6
        .title.font-size-12 個案-集團
        el-input(
          v-model="filterCorp"
          clearable
          placeholder="包含關鍵字"
          style="width: 180px")
      .col.flex.column.align-start.gap-6
        .title.font-size-12 個案-公司
        el-input(
          v-model="filterCompany"
          clearable
          placeholder="包含關鍵字"
          style="width: 180px")
      .col.flex.column.align-start.gap-6
        .title.font-size-12 個案-單位
        el-input(
          v-model="filterDepartment"
          clearable
          placeholder="包含關鍵字"
          style="width: 180px")
      .col.flex-1
      .col.flex.align-center.gap-8
        el-button(type="primary", @click="loadData", :disabled="!canQuery") 查詢
        el-button(@click="resetForm") 重設
  .meta-bar.flex.align-center.gap-12(v-if="meta")
    el-tag(size="mini", type="info") 共 {{ meta.row_count }} 列
    el-tag(size="mini", type="info") 耗時 {{ meta.elapsed_ms }} ms
    el-tag(size="mini", type="warning",
      v-if="meta.default_filters_applied && meta.default_filters_applied.length") 已套用預設過濾：{{ defaultFiltersText }}
    el-tag(size="mini", type="info", v-if="hasPercentMetrics") 百分比基準：{{ percentBaseLabel }}
  .empty(v-if="!loading && rows.length === 0 && hasQueried") 查無資料，請調整查詢條件
  template(v-if="rows.length > 0")
    .summary.flex.gap-12.flex-wrap(v-if="metrics.length > 0")
      .summary-card(v-for="m in metrics", :key="m")
        .label.font-size-12 {{ metricLabel(m) }} 總計
        .value.font-size-20 {{ formatMetric(m, summary[m]) }}
    .view-toggle.flex.align-center.justify-between
      .section-title.font-size-14 結果檢視
      el-radio-group(v-model="viewMode", size="small")
        el-radio-button(label="chart") 圖表模式
        el-radio-button(label="table") 表格模式
    .chart-section(v-show="viewMode === 'chart'")
      .chart-grid.flex.column.gap-16
        .chart-card(v-for="(m, idx) in metrics", :key="`chart-${m}`")
          .chart-title.font-size-14.mb-8 {{ metricLabel(m) }}（{{ bucketLabel(timeBucket) }}）
          .chart-canvas-wrap
            canvas(ref="chartCanvases")
          .chart-actions.flex.justify-end.mt-8
            el-button(size="mini", icon="el-icon-download", @click="downloadChart(idx, m)") 下載圖表
    .table-section(v-show="viewMode === 'table'")
      .table-actions.flex.justify-end.mb-8
        el-button(size="mini", icon="el-icon-download", @click="downloadCsv") 下載 csv
      el-table(:data="rows", border, stripe, size="small", max-height="520")
        el-table-column(prop="time", label="時間", width="140", fixed)
          template(slot-scope="scope")
            span {{ formatTime(scope.row.time) }}
        el-table-column(
          v-for="d in dimensions"
          :key="`dim-${d}`"
          :prop="d"
          :label="dimensionLabel(d)"
          :min-width="140")
          template(slot-scope="scope")
            span {{ formatDimension(d, scope.row[d]) }}
        el-table-column(
          v-for="m in metrics"
          :key="`m-${m}`"
          :prop="m"
          :label="metricLabel(m)"
          align="right"
          :min-width="140")
          template(slot-scope="scope")
            span {{ formatMetric(m, scope.row[m]) }}
            span.percent-text(v-if="rowPercentText(m, scope.row)") {{ rowPercentText(m, scope.row) }}
</template>

<script>
import { mapGetters } from 'vuex';
import { Chart, registerables } from 'chart.js';
import { getStatisticsCatalog, queryAppointmentStatistics } from '@/api/statistics';
import { getBranches } from '@/api/place';
import { getProfessionalList } from '@/api/professionals';
import { getOrganizations } from '@/api/project';
import msg from '@/util/msg';

Chart.register(...registerables);

const CHART_COLORS = [
  '#2f7adb', '#ef6c00', '#43a047', '#8e24aa', '#e53935',
  '#00897b', '#fbc02d', '#5e35b1', '#039be5', '#c0ca33',
  '#d81b60', '#6d4c41',
];
const SERIES_LIMIT = 12;

const DIMENSION_LABELS = {
  appointment_type: '預約類型',
  appointment_subtype: '預約子類型',
  main_requirement_type: '議題',
  location_type: '地點類型',
  location_mode: '地點模式',
  payment_method: '付款方式',
  receipt_status: '收據狀態',
  confirm_status: '確認狀態',
  branch_id: '館別',
  room_id: '空間',
  professional_id: '專業人士',
  patient_id: '個案',
  project_id: '專案',
  organization_id: '組織',
  accounting_model_id: '收費模式',
  accounting_model_type: '收費模式類型',
  'patient.gender': '個案-性別',
  'patient.company': '個案-公司',
  'patient.department': '個案-單位',
  'patient.education': '個案-學歷',
  'patient.county': '個案-縣市',
  'patient.refer_source': '個案-推薦來源',
  is_paid: '是否已付款',
  is_cancelled: '是否取消',
  has_project: '是否有專案',
  is_first_for_patient: '是否首次預約',
  patient_age_bucket: '個案年齡層',
  price_bucket: '價格區間',
  duration_bucket: '時長區間',
  has_partners: '是否有夥伴',
};

const METRIC_LABELS = {
  count: '預約數',
  count_distinct_patient: '個案數',
  count_distinct_professional: '專業人士數',
  count_distinct_project: '專案數',
  sum_price: '總金額',
  avg_price: '平均金額',
  avg_duration_minutes: '平均時長(分)',
  sum_professional_profit: '專業人士收入',
  sum_organization_profit: '組織收入',
};

const BUCKET_LABELS = {
  none: '不分時間',
  year: '年',
  quarter: '季',
  month: '月',
  financial_month: '財管月',
  iso_week: 'ISO 週',
  day: '日',
  hour: '小時',
  day_of_week: '星期',
  hour_of_day: '時段',
};

// 後端 location_mode 維度以 CASE WHEN 從 location_type 推導
const LOCATION_MODE_LABELS = {
  remote: '遠距',
  phone: '電話',
  onsite: '實體',
  unknown: '未知',
};

// appointments.main_requirement_type 的五種值，與預約建立/編輯側欄一致
const MAIN_REQUIREMENT_TYPE_LABELS = {
  mental: '心理諮詢',
  law: '法律諮詢',
  finance: '財務諮詢',
  management: '組織管理',
  medical: '健康管理',
};

// 後端 appointments.appointment_subtype（親子預約）
const APPOINTMENT_SUBTYPE_LABELS = {
  statutoryagents: '法代',
  children: '子女',
};

// 後端 appointments.receipt_status
const RECEIPT_STATUS_LABELS = {
  not_created: '未開立',
  creating: '開立中',
  sent: '已寄送',
};

// 後端 accounting_models.type，與分帳模組設定頁用語一致
const ACCOUNTING_MODEL_TYPE_LABELS = {
  ratio: '比例分配',
  fixedprice: '定額分配',
};

const GENDER_LABELS = {
  male: '男',
  female: '女',
  other: '其他',
};

// 後端衍生維度（dimensions.py）的區間值
const BUCKET_VALUE_LABELS = {
  patient_age_bucket: {
    '0-19': '0-19 歲',
    '20-29': '20-29 歲',
    '30-39': '30-39 歲',
    '40-49': '40-49 歲',
    '50-59': '50-59 歲',
    '60+': '60 歲以上',
    unknown: '未知',
  },
  price_bucket: {
    '<1000': '未滿 1,000',
    '1000-2999': '1,000-2,999',
    '3000-4999': '3,000-4,999',
    '5000+': '5,000 以上',
  },
  duration_bucket: {
    '<60min': '未滿 60 分鐘',
    '60-89min': '60-89 分鐘',
    '90-119min': '90-119 分鐘',
    '120min+': '120 分鐘以上',
  },
};

// 後端 meta.default_filters_applied 的預設過濾條件
const DEFAULT_FILTER_LABELS = {
  'deleted=false': '已排除已取消的預約',
};

// 後端統計查詢（query.py 等）回傳的英文錯誤句，對照成中文原因
const STATISTICS_ERROR_PATTERNS = [
  [/^time_window cannot exceed (\d+) days/, (m) => `查詢區間不可超過 ${m[1]} 天`],
  [/^time_window\.start and time_window\.end/, () => '請選擇查詢時間區間'],
  [/^time_window\.end must be greater/, () => '結束時間必須晚於開始時間'],
  [/^at most (\d+) dimensions/, (m) => `維度最多只能選 ${m[1]} 個`],
  [/^metrics must be a non-empty list/, () => '請至少選擇一項指標'],
  [/^unknown dimension/, () => '不支援的維度'],
  [/^unknown metric/, () => '不支援的指標'],
  [/^unknown field/, () => '不支援的篩選欄位'],
  [/^(invalid|unknown) (time_)?bucket/, () => '不支援的時間分組'],
  [/^unsupported timezone/, () => '不支援的時區'],
  [/^limit must be between/, () => '查詢筆數超出上限'],
];

const DAY_OF_WEEK_LABELS = {
  1: '週一', 2: '週二', 3: '週三', 4: '週四', 5: '週五', 6: '週六', 7: '週日',
};

const COUNT_METRICS = new Set([
  'count', 'count_distinct_patient', 'count_distinct_professional', 'count_distinct_project',
]);

const PRICE_METRICS = new Set([
  'sum_price', 'avg_price', 'sum_professional_profit', 'sum_organization_profit',
]);

export default {
  data() {
    return {
      catalog: {
        dimensions: [],
        metrics: [],
        time_buckets: ['day', 'iso_week', 'month', 'quarter', 'year', 'financial_month',
          'hour', 'hour_of_day', 'day_of_week', 'none'],
        timezones: ['Asia/Taipei'],
        operators: [],
      },
      branches: [],
      professionals: [],
      organizations: [],
      times: [],
      timeField: 'start_at',
      timeBucket: 'month',
      timezone: 'Asia/Taipei',
      dimensions: [],
      metrics: ['count', 'sum_price'],
      filterBranches: [],
      filterAppointmentTypes: [],
      filterMainRequirements: [],
      filterProfessionals: [],
      filterProjects: [],
      projectQuery: '',
      filterRecordTags: [],
      filterCorp: '',
      filterCompany: '',
      filterDepartment: '',
      includeCancelled: false,
      quickRange: 'thisMonth',
      rows: [],
      meta: null,
      loading: false,
      hasQueried: false,
      viewMode: 'chart',
      chartInstances: [],
      datePickerOptions: {
        shortcuts: [
          {
            text: '本月',
            onClick: (picker) => {
              const start = new Date();
              start.setDate(1);
              start.setHours(0, 0, 0, 0);
              const end = new Date();
              end.setHours(23, 59, 59, 999);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '上月',
            onClick: (picker) => {
              const start = new Date();
              start.setMonth(start.getMonth() - 1, 1);
              start.setHours(0, 0, 0, 0);
              const end = new Date(start);
              end.setMonth(end.getMonth() + 1);
              end.setMilliseconds(-1);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['isAdmin', 'isAdvStaff', 'isDispatcher', 'isAccounting']),
    defaultFiltersText() {
      return (this.meta?.default_filters_applied || [])
        .map((f) => DEFAULT_FILTER_LABELS[f] || f)
        .join('、');
    },
    appointmentTypeOptions() {
      return Object.entries(msg.appointment.type).map(([value, label]) => ({ value, label }));
    },
    mainRequirementTypeOptions() {
      return Object.entries(MAIN_REQUIREMENT_TYPE_LABELS)
        .map(([value, label]) => ({ value, label }));
    },
    professionalOptions() {
      return this.professionals
        .map((p) => ({ value: p.id, label: this.professionalMap[p.id] }))
        .sort((a, b) => String(a.label).localeCompare(String(b.label), 'zh-Hant'));
    },
    // 專案依所屬組織分群，避免不同組織的同名專案分不出來
    // 篩選時，組織名稱符合就整組顯示；否則只顯示名稱符合的專案
    projectOptionGroups() {
      const q = this.projectQuery.trim().toLowerCase();
      const match = (text) => String(text || '').toLowerCase().includes(q);
      return this.organizations
        .map((o) => {
          const orgMatched = !q || match(o.name);
          return {
            label: o.name,
            options: (o.projects || [])
              .filter((p) => orgMatched || match(p.name))
              .map((p) => ({ value: p.id, label: p.name })),
          };
        })
        .filter((g) => g.options.length > 0);
    },
    recordTagGroups() {
      return (msg.tag.main_requirement_groups || []).map((g) => ({
        type: g.type,
        label: g.label,
        options: g.tags.map((name) => ({
          value: name,
          label: msg.tag.main_requirement[name] || name,
        })),
      }));
    },
    canQuery() {
      return this.times && this.times.length === 2 && this.metrics.length > 0;
    },
    branchMap() {
      const map = {};
      this.branches.forEach((b) => { map[b.id] = b.name; });
      return map;
    },
    professionalMap() {
      const map = {};
      this.professionals.forEach((p) => {
        const fullName = `${p.family_name || ''}${p.given_name || ''}`.trim() || p.name || `#${p.id}`;
        map[p.id] = fullName;
      });
      return map;
    },
    organizationMap() {
      const map = {};
      this.organizations.forEach((o) => { map[o.id] = o.name; });
      return map;
    },
    projectMap() {
      const map = {};
      this.organizations.forEach((o) => {
        (o.projects || []).forEach((p) => { map[p.id] = p.name; });
      });
      return map;
    },
    roomMap() {
      const map = {};
      this.branches.forEach((b) => {
        (b.rooms || []).forEach((r) => { map[r.id] = r.name; });
      });
      return map;
    },
    primaryMetric() {
      return this.metrics[0];
    },
    hasPercentMetrics() {
      return this.metrics.some((m) => COUNT_METRICS.has(m));
    },
    percentBaseLabel() {
      return this.timeBucket === 'none' ? '整體總計' : '各時間點內佔比';
    },
    // 數量類指標的百分比分母。time_bucket 為 none 時用整份結果的總和，
    // 否則以「同一個時間點」為一組各自加總（每個時間點內加總為 100%）。
    // 分母一律涵蓋所有資料列，不受圖表 SERIES_LIMIT 截斷影響。
    percentTotals() {
      const out = {};
      this.metrics.forEach((m) => {
        if (!COUNT_METRICS.has(m)) return;
        let grand = 0;
        const byTime = new Map();
        this.rows.forEach((r) => {
          const v = Number(r[m]) || 0;
          grand += v;
          const key = this.formatTime(r.time);
          byTime.set(key, (byTime.get(key) || 0) + v);
        });
        out[m] = { grand, byTime };
      });
      return out;
    },
    summary() {
      const out = {};
      this.metrics.forEach((m) => {
        if (COUNT_METRICS.has(m) || PRICE_METRICS.has(m)) {
          out[m] = this.rows.reduce((acc, r) => acc + (Number(r[m]) || 0), 0);
        } else {
          // 平均類指標：取算術平均
          const vals = this.rows.map((r) => Number(r[m])).filter((v) => !Number.isNaN(v));
          out[m] = vals.length === 0 ? 0 : vals.reduce((a, b) => a + b, 0) / vals.length;
        }
      });
      return out;
    },
  },
  watch: {
    viewMode(val) {
      if (val === 'chart') {
        this.$nextTick(() => this.renderCharts());
      }
    },
    rows() {
      if (this.viewMode === 'chart') {
        this.$nextTick(() => this.renderCharts());
      }
    },
  },
  methods: {
    onProjectFilter(query) {
      this.projectQuery = query || '';
    },
    bucketLabel(b) {
      return BUCKET_LABELS[b] || b;
    },
    dimensionLabel(d) {
      return DIMENSION_LABELS[d] || d;
    },
    metricLabel(m) {
      return METRIC_LABELS[m] || m;
    },
    formatTime(t) {
      if (!t) return '';
      if (this.timeBucket === 'day_of_week') {
        return DAY_OF_WEEK_LABELS[t] || t;
      }
      if (this.timeBucket === 'hour_of_day') {
        return `${t}:00`;
      }
      if (this.timeBucket === 'none') {
        return '全部';
      }
      return t;
    },
    formatDimension(dim, val) {
      if (val === null || val === undefined || val === '') {
        return '—';
      }
      if (dim === 'branch_id') {
        return this.branchMap[val] || `#${val}`;
      }
      if (dim === 'professional_id') {
        return this.professionalMap[val] || `#${val}`;
      }
      if (dim === 'organization_id') {
        return this.organizationMap[val] || `#${val}`;
      }
      if (dim === 'project_id') {
        return this.projectMap[val] || `#${val}`;
      }
      if (dim === 'room_id') {
        return this.roomMap[val] || `#${val}`;
      }
      if (dim === 'appointment_type') {
        return msg.appointment.type[val] || val;
      }
      if (dim === 'location_type') {
        return msg.appointment.locationType[val] || val;
      }
      if (dim === 'location_mode') {
        return LOCATION_MODE_LABELS[val] || val;
      }
      if (dim === 'main_requirement_type') {
        return MAIN_REQUIREMENT_TYPE_LABELS[val] || val;
      }
      if (dim === 'payment_method') {
        return msg.appointment.payment[val] || val;
      }
      if (dim === 'appointment_subtype') {
        return APPOINTMENT_SUBTYPE_LABELS[val] || val;
      }
      if (dim === 'receipt_status') {
        return RECEIPT_STATUS_LABELS[val] || val;
      }
      if (dim === 'confirm_status') {
        return msg.confirm_status[val] || val;
      }
      if (dim === 'accounting_model_type') {
        return ACCOUNTING_MODEL_TYPE_LABELS[val] || val;
      }
      if (dim === 'patient.education') {
        return msg.appointment.education[val] || val;
      }
      if (BUCKET_VALUE_LABELS[dim]) {
        return BUCKET_VALUE_LABELS[dim][val] || val;
      }
      if (dim === 'patient.gender') {
        return GENDER_LABELS[val] || val;
      }
      if (typeof val === 'boolean') {
        return val ? '是' : '否';
      }
      return val;
    },
    formatMetric(m, v) {
      if (v === null || v === undefined) return '—';
      if (PRICE_METRICS.has(m)) {
        return `$${Math.round(Number(v)).toLocaleString()}`;
      }
      if (COUNT_METRICS.has(m)) {
        return Number(v).toLocaleString();
      }
      // avg_duration_minutes 等浮點
      return Number(v).toFixed(1);
    },
    // 回傳百分比數值（0～100），無法計算時回傳 null
    metricPercent(metric, value, timeLabel) {
      const totals = this.percentTotals[metric];
      if (!totals) return null;
      const base = this.timeBucket === 'none'
        ? totals.grand
        : (totals.byTime.get(timeLabel) || 0);
      if (!base) return null;
      const v = Number(value);
      if (value === null || value === undefined || Number.isNaN(v)) return null;
      return (v / base) * 100;
    },
    formatPercent(p) {
      return `${p.toFixed(1)}%`;
    },
    // 「數量 (百分比%)」；非數量類指標或分母為 0 時只回傳數量
    formatMetricWithPercent(metric, value, timeLabel) {
      const text = this.formatMetric(metric, value);
      const p = this.metricPercent(metric, value, timeLabel);
      if (p === null) return text;
      return `${text} (${this.formatPercent(p)})`;
    },
    rowPercentText(metric, row) {
      const p = this.metricPercent(metric, row[metric], this.formatTime(row.time));
      return p === null ? '' : `(${this.formatPercent(p)})`;
    },
    formatChartTick(metric, v) {
      if (PRICE_METRICS.has(metric)) {
        const n = Number(v);
        if (Math.abs(n) >= 10000) {
          return `${(n / 10000).toLocaleString(undefined, { maximumFractionDigits: 1 })}萬`;
        }
        return n.toLocaleString();
      }
      return Number(v).toLocaleString();
    },
    buildChartConfig(metric) {
      const isTimeSeries = this.timeBucket !== 'none';
      const seriesMap = new Map();
      const timeSet = new Set();
      this.rows.forEach((r) => {
        const dimKey = this.dimensions.map((d) => this.formatDimension(d, r[d])).join(' / ') || '總計';
        const time = this.formatTime(r.time);
        timeSet.add(time);
        if (!seriesMap.has(dimKey)) seriesMap.set(dimKey, new Map());
        seriesMap.get(dimKey).set(time, Number(r[metric]) || 0);
      });
      const labels = Array.from(timeSet).sort();
      let entries = Array.from(seriesMap.entries()).sort((a, b) => {
        const sumA = Array.from(a[1].values()).reduce((s, v) => s + v, 0);
        const sumB = Array.from(b[1].values()).reduce((s, v) => s + v, 0);
        return sumB - sumA;
      });
      const truncated = entries.length > SERIES_LIMIT;
      if (truncated) {
        entries = entries.slice(0, SERIES_LIMIT);
      }

      let datasets;
      if (isTimeSeries) {
        datasets = entries.map(([key, dataMap], idx) => ({
          label: key,
          data: labels.map((l) => dataMap.get(l) || 0),
          borderColor: CHART_COLORS[idx % CHART_COLORS.length],
          backgroundColor: `${CHART_COLORS[idx % CHART_COLORS.length]}33`,
          borderWidth: 2,
          tension: 0.25,
          fill: false,
          pointRadius: 3,
        }));
      } else {
        datasets = [{
          label: this.metricLabel(metric),
          data: entries.map(([, dataMap]) => Array.from(dataMap.values()).reduce((s, v) => s + v, 0)),
          backgroundColor: entries.map((_, idx) => CHART_COLORS[idx % CHART_COLORS.length]),
          borderWidth: 0,
        }];
      }
      const chartLabels = isTimeSeries ? labels : entries.map(([k]) => k);

      return {
        type: isTimeSeries ? 'line' : 'bar',
        data: { labels: chartLabels, datasets },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: { mode: 'index', intersect: false },
          plugins: {
            legend: {
              display: isTimeSeries && datasets.length > 1,
              position: 'bottom',
              labels: {
                boxWidth: 12,
                font: { size: 11 },
                // 圖例顯示「系列名 (該系列佔整體總量的百分比)」
                generateLabels: (chart) => {
                  const items = Chart.defaults.plugins.legend.labels.generateLabels(chart);
                  const { grand } = this.percentTotals[metric] || {};
                  if (!grand) return items;
                  return items.map((item) => {
                    const ds = chart.data.datasets[item.datasetIndex];
                    if (!ds) return item;
                    const sum = (ds.data || []).reduce((s, v) => s + (Number(v) || 0), 0);
                    return {
                      ...item,
                      text: `${item.text} (${this.formatPercent((sum / grand) * 100)})`,
                    };
                  });
                },
              },
            },
            tooltip: {
              callbacks: {
                label: (ctx) => {
                  const value = ctx.parsed.y ?? ctx.parsed;
                  const timeLabel = isTimeSeries ? chartLabels[ctx.dataIndex] : null;
                  return `${ctx.dataset.label}: ${this.formatMetricWithPercent(metric, value, timeLabel)}`;
                },
              },
            },
            subtitle: truncated ? {
              display: true,
              text: `（僅顯示前 ${SERIES_LIMIT} 項，共 ${seriesMap.size} 項）`,
              font: { size: 11 },
              color: '#909399',
            } : { display: false },
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: { callback: (v) => this.formatChartTick(metric, v) },
            },
          },
        },
      };
    },
    destroyCharts() {
      this.chartInstances.forEach((c) => {
        try { c.destroy(); } catch (e) { /* noop */ }
      });
      this.chartInstances = [];
    },
    renderCharts() {
      this.destroyCharts();
      const canvases = this.$refs.chartCanvases;
      if (!canvases || canvases.length === 0 || this.rows.length === 0) {
        return;
      }
      this.metrics.forEach((metric, idx) => {
        const canvas = canvases[idx];
        if (!canvas) return;
        const cfg = this.buildChartConfig(metric);
        this.chartInstances.push(new Chart(canvas, cfg));
      });
    },
    triggerDownload(href, filename) {
      const link = document.createElement('a');
      link.href = href;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    csvEscape(val) {
      if (val === null || val === undefined) return '';
      const s = String(val);
      if (/[",\n\r]/.test(s)) {
        return `"${s.replace(/"/g, '""')}"`;
      }
      return s;
    },
    timestampSuffix() {
      const d = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
    },
    downloadCsv() {
      if (this.rows.length === 0) {
        this.$message.warning('沒有可下載的資料');
        return;
      }
      const headers = ['時間', ...this.dimensions.map((d) => this.dimensionLabel(d))];
      this.metrics.forEach((m) => {
        headers.push(this.metricLabel(m));
        // 數量類指標另外獨立一欄放百分比，方便在試算表裡直接運算
        if (COUNT_METRICS.has(m)) {
          headers.push(`${this.metricLabel(m)}佔比(%)`);
        }
      });
      const lines = [headers.map(this.csvEscape).join(',')];
      this.rows.forEach((r) => {
        const timeLabel = this.formatTime(r.time);
        const cells = [
          timeLabel,
          ...this.dimensions.map((d) => this.formatDimension(d, r[d])),
        ];
        this.metrics.forEach((m) => {
          const v = r[m];
          cells.push(v === null || v === undefined ? '' : Number(v));
          if (COUNT_METRICS.has(m)) {
            const p = this.metricPercent(m, v, timeLabel);
            cells.push(p === null ? '' : Number(p.toFixed(1)));
          }
        });
        lines.push(cells.map(this.csvEscape).join(','));
      });
      const csv = `\uFEFF${lines.join('\r\n')}`;
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      this.triggerDownload(url, `appointment-statistics-${this.timestampSuffix()}.csv`);
      URL.revokeObjectURL(url);
    },
    downloadChart(idx, metric) {
      const chart = this.chartInstances[idx];
      if (!chart) {
        this.$message.warning('圖表尚未繪製');
        return;
      }
      const dataUrl = chart.toBase64Image('image/png', 1);
      this.triggerDownload(dataUrl, `appointment-statistics-${this.metricLabel(metric)}-${this.timestampSuffix()}.png`);
    },
    applyQuickRange(value) {
      const now = new Date();
      let start; let end;
      if (value === 'thisMonth') {
        start = new Date(now.getFullYear(), now.getMonth(), 1);
        end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      } else if (value === 'lastMonth') {
        start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        end = new Date(now.getFullYear(), now.getMonth(), 0);
      } else if (value === 'last3Months') {
        start = new Date(now.getFullYear(), now.getMonth() - 2, 1);
        end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      } else if (value === 'thisYear') {
        start = new Date(now.getFullYear(), 0, 1);
        end = new Date(now.getFullYear(), 11, 31);
      } else if (value === 'lastYear') {
        start = new Date(now.getFullYear() - 1, 0, 1);
        end = new Date(now.getFullYear() - 1, 11, 31);
      }
      if (start && end) {
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        this.times = [start, end];
      }
    },
    resetForm() {
      this.timeField = 'start_at';
      this.timeBucket = 'month';
      this.timezone = 'Asia/Taipei';
      this.dimensions = [];
      this.metrics = ['count', 'sum_price'];
      this.filterBranches = [];
      this.filterAppointmentTypes = [];
      this.filterMainRequirements = [];
      this.filterProfessionals = [];
      this.filterProjects = [];
      this.projectQuery = '';
      this.filterRecordTags = [];
      this.filterCorp = '';
      this.filterCompany = '';
      this.filterDepartment = '';
      this.includeCancelled = false;
      this.quickRange = 'thisMonth';
      this.applyQuickRange('thisMonth');
      this.rows = [];
      this.meta = null;
      this.hasQueried = false;
    },
    buildSpec() {
      const [start, end] = this.times;
      const startSec = Math.floor(new Date(start).setHours(0, 0, 0, 0) / 1000);
      const endSec = Math.floor(new Date(end).setHours(23, 59, 59, 999) / 1000) + 1;
      const filterClauses = [];
      if (this.filterBranches.length > 0) {
        filterClauses.push({ field: 'branch_id', op: 'in', value: this.filterBranches });
      }
      if (this.filterAppointmentTypes.length > 0) {
        filterClauses.push({ field: 'appointment_type', op: 'in', value: this.filterAppointmentTypes });
      }
      if (this.filterMainRequirements.length > 0) {
        filterClauses.push({ field: 'main_requirement_type', op: 'in', value: this.filterMainRequirements });
      }
      if (this.filterProfessionals.length > 0) {
        filterClauses.push({ field: 'professional_id', op: 'in', value: this.filterProfessionals });
      }
      if (this.filterProjects.length > 0) {
        filterClauses.push({ field: 'project_id', op: 'in', value: this.filterProjects });
      }
      // 子查詢欄位，只支援 eq/ne/in/not_in/contains/is_null
      if (this.filterRecordTags.length > 0) {
        filterClauses.push({ field: 'record.main_requirement_tag', op: 'in', value: this.filterRecordTags });
      }
      // 集團／公司／單位是自由文字且未正規化，用 contains 模糊比對
      [
        ['patient.corp', this.filterCorp],
        ['patient.company', this.filterCompany],
        ['patient.department', this.filterDepartment],
      ].forEach(([field, keyword]) => {
        const v = (keyword || '').trim();
        if (v) {
          filterClauses.push({ field, op: 'contains', value: v });
        }
      });
      if (this.includeCancelled) {
        filterClauses.push({ field: 'deleted', op: 'in', value: [true, false] });
      }
      const spec = {
        time_field: this.timeField,
        time_window: { start: startSec, end: endSec },
        time_bucket: this.timeBucket,
        timezone: this.timezone,
        dimensions: this.dimensions,
        metrics: this.metrics,
      };
      if (filterClauses.length === 1) {
        [spec.filter] = filterClauses;
      } else if (filterClauses.length > 1) {
        spec.filter = { and: filterClauses };
      }
      return spec;
    },
    async loadData() {
      if (!this.canQuery) {
        this.$message.warning('請選擇時間區間並至少指定一項指標');
        return;
      }
      const spec = this.buildSpec();
      this.loading = true;
      await this.$execWithLoading(async () => {
        const rsp = await queryAppointmentStatistics(spec);
        this.rows = rsp.data || [];
        this.meta = rsp.meta || null;
        this.hasQueried = true;
      }, (e) => {
        const reason = this.statisticsErrorText(e?.response?.data?.error);
        if (reason) {
          this.$showError(`查詢統計失敗: ${reason}`);
          return;
        }
        this.$showAxiosException('查詢統計失敗', e);
      });
      this.loading = false;
    },
    statisticsErrorText(raw) {
      if (typeof raw !== 'string') {
        return '';
      }
      const found = STATISTICS_ERROR_PATTERNS.find(([re]) => re.test(raw));
      return found ? found[1](raw.match(found[0])) : '';
    },
    async loadCatalog() {
      try {
        const c = await getStatisticsCatalog();
        if (c && c.dimensions && c.metrics) {
          this.catalog = c;
        }
      } catch (e) {
        // 目錄載入失敗時「維度」「指標」下拉沒有選項，需提示使用者
        // eslint-disable-next-line no-console
        console.warn('catalog fetch failed', e);
        this.$showAxiosException('載入統計目錄失敗', e);
      }
    },
    async loadAuxData() {
      try {
        this.branches = await getBranches();
      } catch (e) {
        this.branches = [];
      }
      try {
        this.professionals = await getProfessionalList();
      } catch (e) {
        this.professionals = [];
      }
      try {
        this.organizations = await getOrganizations();
      } catch (e) {
        this.organizations = [];
      }
    },
  },
  async mounted() {
    if (!this.isAdmin && !this.isAdvStaff && !this.isDispatcher && !this.isAccounting) {
      this.$router.push('/reserve');
      return;
    }
    this.applyQuickRange('thisMonth');
    await Promise.all([this.loadCatalog(), this.loadAuxData()]);
    await this.loadData();
  },
  beforeDestroy() {
    this.destroyCharts();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.statistics-page {
  padding: 24px;
  gap: 16px;
  overflow: auto;
}
.toolbar {
  background: white;
  padding: 16px;
  border-radius: 6px;
  border: 1px solid $border-light-color;
}
.title {
  color: $text-secondary-color;
}
.date-range-input {
  min-width: 320px;
}
.fill {
  width: 100%;
}
.flex-wrap {
  flex-wrap: wrap;
}
.meta-bar {
  flex-wrap: wrap;
}
.empty {
  padding: 60px 0;
  text-align: center;
  color: $text-secondary-color;
}
.summary-card {
  flex: 0 0 auto;
  min-width: 160px;
  background: white;
  border: 1px solid $border-light-color;
  border-radius: 6px;
  padding: 12px 16px;
  .label {
    color: $text-secondary-color;
  }
  .value {
    font-weight: 600;
    margin-top: 4px;
  }
}
.section-title {
  font-weight: 600;
  color: $text-regular-color;
}
.percent-text {
  margin-left: 4px;
  color: $text-secondary-color;
}
.chart-section,
.table-section {
  background: white;
  padding: 16px;
  border-radius: 6px;
  border: 1px solid $border-light-color;
}
.view-toggle {
  background: white;
  padding: 12px 16px;
  border-radius: 6px;
  border: 1px solid $border-light-color;
}
.chart-card {
  border: 1px solid $border-light-color;
  border-radius: 4px;
  padding: 12px 16px 16px;
  .chart-title {
    font-weight: 600;
    color: $text-regular-color;
  }
}
.chart-canvas-wrap {
  position: relative;
  height: 320px;
}
.chart-actions {
  margin-top: 12px;
}
.table-actions {
  margin-bottom: 12px;
}
</style>
